export default __webpack_public_path__ + "static/media/scan-panda-logo.48eb07ab.png";